'use client';
import { useEffect, useState } from 'react';

const SCROLL_THRESHOLD_MOBILE = 48;
const SCROLL_THRESHOLD_DESKTOP = 96;
const DESKTOP_BREAKPOINT = 1024;

export const useFullBleedNavScroll = (enabled = false) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setScrolled(false);
      return;
    }

    const check = () => {
      const threshold =
        window.innerWidth < DESKTOP_BREAKPOINT
          ? SCROLL_THRESHOLD_MOBILE
          : SCROLL_THRESHOLD_DESKTOP;
      setScrolled(window.scrollY > threshold);
    };

    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check, { passive: true });

    return () => {
      window.removeEventListener('scroll', check);
      window.removeEventListener('resize', check);
    };
  }, [enabled]);

  return scrolled;
};
